import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';

// Layouts
import MainLayout from './layouts/MainLayout';

// Main Pages
import Home from './pages/main/Home';
import About from './pages/main/About';
import OurSchools from './pages/main/OurSchools';
import Admissions from './pages/main/Admissions';
import Gallery from './pages/main/Gallery';
import NewsEvents from './pages/main/NewsEvents';
import Contact from './pages/main/Contact';

// Montessori Pages
import MontessoriOverview from './pages/montessori/Overview';
import MontessoriCurriculum from './pages/montessori/Curriculum';
import MontessoriFacilities from './pages/montessori/Facilities';
import MontessoriGallery from './pages/montessori/Gallery';
import MontessoriContact from './pages/montessori/Contact';

// College Pages
import CollegeOverview from './pages/college/Overview';
import CollegeAcademics from './pages/college/Academics';
import CollegeExtracurriculars from './pages/college/Extracurriculars';
import CollegeAchievements from './pages/college/Achievements';
import CollegeGallery from './pages/college/Gallery';
import CollegeContact from './pages/college/Contact';

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        {/* Main Site Routes */}
        <Route element={<MainLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/our-schools" element={<OurSchools />} />
          <Route path="/admissions" element={<Admissions />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/news" element={<NewsEvents />} />
          <Route path="/contact" element={<Contact />} />
        </Route>

        {/* Montessori Routes */}
        <Route element={<MainLayout division="montessori" />}>
          <Route path="/montessori" element={<MontessoriOverview />} />
          <Route path="/montessori/curriculum" element={<MontessoriCurriculum />} />
          <Route path="/montessori/facilities" element={<MontessoriFacilities />} />
          <Route path="/montessori/gallery" element={<MontessoriGallery />} />
          <Route path="/montessori/contact" element={<MontessoriContact />} />
        </Route>

        {/* College Routes */}
        <Route element={<MainLayout division="college" />}>
          <Route path="/college" element={<CollegeOverview />} />
          <Route path="/college/academics" element={<CollegeAcademics />} />
          <Route path="/college/extracurriculars" element={<CollegeExtracurriculars />} />
          <Route path="/college/achievements" element={<CollegeAchievements />} />
          <Route path="/college/gallery" element={<CollegeGallery />} />
          <Route path="/college/contact" element={<CollegeContact />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
